import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CreditCard, Building2, Smartphone } from 'lucide-react';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';

export default function PaymentInfo() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNav activeItem="Payment Info" />

      <section className="py-24 bg-slate-50" data-testid="payment-info-page">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-accent mb-4">PAYMENT OPTIONS</p>
            <h1 className="text-5xl sm:text-6xl tracking-tighter font-light text-brand-primary font-outfit mb-6">How to Pay</h1>
            <p className="text-lg text-slate-600">We accept multiple payment methods for your convenience</p>
          </motion.div>

          <div className="space-y-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white p-8 border border-slate-200"
            >
              <div className="flex items-start space-x-4">
                <CreditCard className="h-8 w-8 text-brand-accent flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="text-xl font-medium text-brand-primary mb-3">Cash on Delivery</h3>
                  <p className="text-slate-600 mb-4">Pay with cash when our delivery person arrives at your location. Most convenient and preferred method.</p>
                  <div className="bg-brand-cyan-light p-4">
                    <p className="text-sm text-brand-primary font-medium">✅ No advance payment required</p>
                    <p className="text-sm text-brand-primary font-medium">✅ Pay exact amount or get change</p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white p-8 border border-slate-200"
            >
              <div className="flex items-start space-x-4">
                <Building2 className="h-8 w-8 text-brand-accent flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="text-xl font-medium text-brand-primary mb-3">Bank Transfer</h3>
                  <p className="text-slate-600 mb-4">Transfer directly to our bank account. Please share payment screenshot via WhatsApp after transfer.</p>
                  <div className="bg-slate-50 p-4 border border-slate-200 space-y-2">
                    <p className="text-sm text-slate-700"><span className="font-medium">Bank Name:</span> Habib Bank Limited (HBL)</p>
                    <p className="text-sm text-slate-700"><span className="font-medium">Account Title:</span> Aneeb Ahmad</p>
                    <p className="text-sm text-slate-700"><span className="font-medium">Account Number:</span> 22977107147203</p>
                    {/* <p className="text-sm text-slate-700"><span className="font-medium">IBAN:</span> PK12MEZN00022977107147203</p> */}
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-white p-8 border border-slate-200"
            >
              <div className="flex items-start space-x-4">
                <Smartphone className="h-8 w-8 text-brand-accent flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="text-xl font-medium text-brand-primary mb-3">JazzCash</h3>
                  <p className="text-slate-600 mb-4">Send payment via mobile wallet and share screenshot on WhatsApp.</p>
                  <div className="bg-slate-50 p-4 border border-slate-200 space-y-2">
                    <p className="text-sm text-slate-700"><span className="font-medium">JazzCash:</span> 0301-7196699</p>
                    <p className="text-sm text-slate-700"><span className="font-medium">Account Name:</span> Aneeb Ahmad</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="mt-12 bg-brand-primary text-white p-8"
          >
            <h3 className="text-xl font-medium mb-4">Payment Instructions</h3>
            <ul className="space-y-2 text-slate-200">
              <li>• After placing your order via WhatsApp, choose your preferred payment method</li>
              <li>• For online payments, share the screenshot with our WhatsApp number</li>
              <li>• Your order will be confirmed once payment is verified</li>
              <li>• Delivery will be scheduled after payment confirmation</li>
            </ul>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
}